export class MobileHeader {
    constructor() {
        this.button = document.querySelector('.js-show-menu');
        this.target = document.querySelector('.js-mobile-header');
        this.close = document.querySelector('.js-close-menu');
        this.body = document.querySelector('body');

        if (!this.button || !this.target || !this.close || !this.body) {
            return false;
        }


        this.attachEvent();
    }

    attachEvent() {
        this.button.onclick = this.clickShowEvent.bind(this);
        this.close.onclick = this.closeClickEvent.bind(this);

        window.onresize = this.resizeEvent.bind(this);
    }

    clickShowEvent(event) {
        event.preventDefault();
        this.target.classList.toggle('active');
        this.body.classList.add('body-lock');
    }

    closeClickEvent(event) {
        event.preventDefault();

        this.target.classList.remove('active');
        this.body.classList.remove('body-lock');
    }

    resizeEvent(event) {
        if (window.screen.width > 768) {
            this.target.classList.remove('active');
            this.body.classList.remove('body-lock');
        }
    }
}